import LoginContainer from "views/containers/auth";

const Login = (): JSX.Element => {
  return <LoginContainer />;
};

export default Login;
